/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownEmploymentType } from '../models/db_DropdownEmploymentType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmploymentTypes {
    /**
     * Get a list of employment types
     * @param isAlumni Alumni employment types
     * @param isApplicant Applicant employment types
     * @returns db_DropdownEmploymentType OK
     * @throws ApiError
     */
    public static listEmploymentTypes(
        isAlumni?: boolean,
        isApplicant?: boolean,
    ): CancelablePromise<Array<db_DropdownEmploymentType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employment-types',
            query: {
                'is_alumni': isAlumni,
                'is_applicant': isApplicant,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
